(function(){

  'use strict';

    // **********************************
    //  Data that this directive needs
    // ----------------------------------
    //
    //

  function pxWorkstationQueues(
    PrintQueueListPaging, $ngBootbox, toastr, $filter, URLS, URL_PARAMS, $location, $routeParams,
    WorkstationListService, EventServiceEvents, Utils, $rootScope
  ) {
    return {
      restrict: 'EA',
      scope: {
        workstation: '=workstation',
        tenant: '=tenant',
        me: '=me',
        isThisResourceMine: '=isThisResourceMine',
        meta: '=meta',
        printQueuesToBeChanged: '=printQueuesToBeChanged',
        storePrintQueuesToBeChanged: '&storePrintQueuesToBeChanged',
        callback: '&callback'
      },
      templateUrl: 'app/components/workstationProperties/workstationQueues/workstationQueues.template.html',
      link: function(scope) {

        scope.workstationOriginal = angular.copy(scope.workstation);


        scope.remoteQueueManagementCalibrationObject = {
          context: 'addManyQueuesToOneWorkstation',
          pagingRequestType: "POST",
          pagingObject: new PrintQueueListPaging,
          searchInputPlaceholderText: "SearchQueueByName",
          setHelpCaptionRemoteQueueManagement: "HelpComputersPropertiesRemoteQueueManagament",
          resetHelpCaptionRemoteQueueManagement: "HelpComputersPropertiesPrintQueues",
          originalModel: scope.workstationOriginal
        };

        scope.searchPattern = "";
        scope.selectAllPrintQueues = {selected: false};
        scope.workingOnIt = false;
        scope.failed = false;

        (function(){
          taskMaintenance('init');
        })();


        scope.rememberAddedPrintqueues = function (printQueues) {
          scope.printQueuesToBeChanged = printQueues;
          scope.storePrintQueuesToBeChanged({printQueuesToBeChanged: scope.printQueuesToBeChanged})
        }

        function taskMaintenance (caller) {
          printQueueMemoryListMaintenance();
        }

        function printQueueMemoryListMaintenance () {
          if (scope.printQueuesToBeChanged.length > 0) {
            scope.workingOnIt = true;
            scope.failed = false;

            for (var i = 0; i < scope.printQueuesToBeChanged.length; i++) {
              if (scope.workstationOriginal.info._embedded.queues) {
                var queue = scope.printQueuesToBeChanged[i];
                if (queue && !queue.info.stagedForRemoval) {

                  for (var j = 0; j < scope.workstationOriginal.info._embedded.queues.length; j++) {
                    if (queue.info._links.self.href === scope.workstationOriginal.info._embedded.queues[j]._links['px:queue'].href) {
                      scope.printQueuesToBeChanged.splice(i, 1);
                      i -= 1;
                    }
                  }
                }
              }
            }

            for (var i = 0; i < scope.printQueuesToBeChanged.length; i++) {
              var queue = scope.printQueuesToBeChanged[i];
              var hasQueueBeenRemoved = 'yes';
              if (queue && queue.info.stagedForRemoval) {
                if (scope.workstationOriginal.info._embedded.queues) {
                  for (var j = 0; j < scope.workstationOriginal.info._embedded.queues.length; j++) {
                    if (queue.info._links.self.href === scope.workstationOriginal.info._embedded.queues[j]._links['px:queue'].href) {
                      hasQueueBeenRemoved = 'not yet';
                    }
                  }

                  if (hasQueueBeenRemoved === 'yes') {
                    scope.printQueuesToBeChanged.splice(i, 1);
                    i -= 1;
                  }

                } else {
                  scope.printQueuesToBeChanged.splice(i, 1);
                  i -= 1;
                }
              }
            }
          } else {
            scope.workingOnIt = false;
          }



          scope.storePrintQueuesToBeChanged({printQueuesToBeChanged: scope.printQueuesToBeChanged})

          printQueueMemoryListMaintenanceOnlyFailedTasksRemainig();
        }

        function printQueueMemoryListMaintenanceOnlyFailedTasksRemainig () {
          var printQueueTaskStatusList = [];
          if (scope.printQueuesToBeChanged.length > 0) {
            for (var i = 0; i < scope.printQueuesToBeChanged.length; i++) {
              if (scope.workstationOriginal.info._embedded.tasks) {
                for (var j = 0; j < scope.workstationOriginal.info._embedded.tasks.length; j++) {
                    var task = scope.workstationOriginal.info._embedded.tasks[j];

                    if (task && task._links['px:queue'] && task._links['px:queue'].href === scope.printQueuesToBeChanged[i].info._links.self.href && task.status === 'FAILED') {
                      printQueueTaskStatusList.push('failed')
                    } else if (task.status === 'PENDING') {
                      printQueueTaskStatusList.push('pending')
                    }
                  }
              }
            }
          } else {
            scope.workingOnIt = false;
            scope.failed = false;
          }

          if (scope.workstationOriginal.info._embedded.tasks && scope.printQueuesToBeChanged.length > scope.workstationOriginal.info._embedded.tasks.length) {
            printQueueTaskStatusList.push('pending')
          }

          var statusTest = (printQueueTaskStatusList.indexOf("pending") > -1);
          if (!statusTest && printQueueTaskStatusList.length > 0) {
            scope.workingOnIt = false;
            scope.failed = true;
          }

        }


        scope.setSection = function(section) {
          scope.showSection = section;

          var url = $location.path();
          $location.path(url, false).search({ workstationSection: section });
          scope.callback();
        }


        scope.setPrinterQueueAsDefault = function (printQueue) {
          $ngBootbox.confirm($filter("translate")("SetAsDefaultPrinter")).then(function() {
            scope.workstation.setDefaultPrintQueue(printQueue._links['px:queue'].href).then(function(response) {
              toastr.success($filter("translate")("ChangesSaved"));
            }).catch(function(error){
              toastr.error($filter("translate")("ERROR"));
            });
          }).catch(function(error){});
        }

        scope.selectAllItems = function() {
          angular.forEach(scope.workstationOriginal.info._embedded.queues, function(value) {
            value['isSelected'] = scope.selectAllPrintQueues.selected;
          });
        };

        scope.watchQueues = function() {
          scope.$watch(function() {
            return scope.workstationOriginal.info._embedded.queues;
          }, function() {
            if (scope.workstationOriginal.info._embedded.queues) {
              scope.selectedQueues = scope.workstationOriginal.info._embedded.queues.findAllElements({
                isSelected: true
              }).length;
              if (!scope.selectedQueues) {
                scope.selectAllPrintQueues.selected = false;
              } else {
                scope.selectAllPrintQueues.selected = (scope.selectedQueues === scope.workstationOriginal.info._embedded.queues.length);
              }
              scope.viewReady = true;
            }
          }, true);
        };

        scope.deleteSelectedPrintQueuesFromWorkstation = function(printQueue) {
          if (scope.workstationOriginal.info._embedded.queues.length > 0) {
            var queueContainer = [];

            if (printQueue) {
              queueContainer.push(printQueue);
            } else {
              queueContainer = scope.workstationOriginal.info._embedded.queues.findAllElements({isSelected: true});
            }

            if (queueContainer.length > 0) {
              var message = "";

              if (queueContainer.length < 2) {
                message = $filter("stringular")($filter("translate")("DeletePrintQueue"), queueContainer[0].name);
              } else {
                message = $filter("stringular")($filter("translate")("DeletePrintQueues"), queueContainer.length);
              }

              $ngBootbox.confirm(message).then(function() {

                scope.printQueuesToBeChanged = makePseudoPrintQueue(queueContainer);
                scope.storePrintQueuesToBeChanged({printQueuesToBeChanged: scope.printQueuesToBeChanged})

                scope.workstationOriginal.deleteSelectedPrintQueues(queueContainer).then(function() {
                  var message = "";
                  if (queueContainer.length < 2) {
                    message = $filter("stringular")($filter("translate")("PrintQueueDeleted"), queueContainer[0].name);
                  } else {
                    message = $filter("stringular")($filter("translate")("PrintQueuesDeleted"), queueContainer.length);
                  }
                  toastr.success(message);
                }).catch(function(error){});
              }).catch(function(error){});
            } else {
              toastr.error($filter("translate")("SelectPrintQueueNone") + ", " + $filter("translate")("SelectPrintQueue"));
            }
          } else {
            toastr.error($filter("translate")("SelectPrintQueueNone"));
          }
        };

        function makePseudoPrintQueue (queueContainer) {
          var pseudoPrintQueueList = [];
          angular.forEach(queueContainer, function  (printQueue) {
            var pseudoPrintQueue = {
              info: {
                name: printQueue.name,
                stagedForRemoval: true,
                _links: {
                  self: {
                    href: printQueue._links['px:queue'].href
                  }
                }
              }
            }
            pseudoPrintQueueList.push(pseudoPrintQueue)
          })

          return pseudoPrintQueueList;
        }

        scope.addPrintQueuesToWorkstation = function(printQueueList) {
          if (printQueueList.length > 0) {
            scope.workstationOriginal.addSelectedPrintQueues(printQueueList).then(function() {
              var message = "";
              if (printQueueList.length < 2) {
                message = $filter("stringular")($filter("translate")("PrintQueueAdded"), printQueueList[0].name);
              } else {
                message = $filter("stringular")($filter("translate")("PrintQueuesAdded"), printQueueList.length);
              }
              toastr.success(message);
            }).catch(function(error){});
          } else {
            throw "scope.addPrintQueuesToWorkstation: printQueueList is missing or empty"
          }
        }

        scope.forceWorkstationToGetLatestQueueUpdates = function(printQueue) {
          if (printQueue) {
            var message = '';
            message = $filter("stringular")($filter("translate")("UpdatePrintQueue"), printQueue.name);
            $ngBootbox.confirm(message).then(function(message) {
              scope.workstationOriginal.forceWorkstationToGetLatestQueueUpdates([printQueue]).then(function() {
                var message = "";
                message = $filter("stringular")($filter("translate")("PrintQueueUpdated"), printQueue.name);
                toastr.success(message);
              }).catch(function(error){});
            }).catch(function(error){});
          } else {
            throw "scope.addPrintQueuesToWorkstation: printQueue is missing"
          }
        }

        scope.refreshQueues = function() {
          scope.workstationOriginal.info._embedded.queues = [];
          angular.element('.paged-items').detach();
          $routeParams[URL_PARAMS.SHOW_WORKSTATION_SECTION.ROUTE] = 'queues';
          scope.initWorkstation();

        }

        scope.convertPrintQueues = function () {
          var workstationID = {
            workstationId: scope.workstation.info._links.self.href
          };
          var workstationIDs = [];
          workstationIDs.push(workstationID);

          scope.tenant.convertWorkstationsPrintQueues(workstationIDs).then(function(){
            toastr.success($filter('translate')('MigrateExistingPrintQueues'));
          }).catch(function(error){
            toastr.error($filter('translate')('Error'));
          });
        }

        scope.isPrintqueuePassingSearchPattern = function(printQueue) {
          if (!scope.searchPattern) {
            return true;
          }

          if (printQueue) {
            if (printQueue.name.toLowerCase().indexOf(scope.searchPattern.toLowerCase()) !== -1) {
              return true;
            }
          }
          return false;
        };


        scope.initWorkstation = function() {
          WorkstationListService.getWorkstationById($routeParams[URL_PARAMS.WORKSTATION_ID.ROUTE]).then(function(workstation) {
            scope.workstation = angular.copy(workstation);
            scope.workstationOriginal = angular.copy(workstation);
            scope.remoteQueueManagementCalibrationObject.originalModel = scope.workstationOriginal;
            scope.watchQueues();
            taskMaintenance('refresh');
          }).catch(function(error){});
        };



        var RELAY_WS_UPDATE_listener = $rootScope.$on('RELAY_WS_UPDATE', function (name, data)   {
          var workstationInScope = Utils.removeDomainFromUrl(scope.workstation.info._links.self.href);
          if (data.workstationInEvent === workstationInScope) {
            scope.workstation = angular.copy(data.workstation);
            scope.workstationOriginal = angular.copy(data.workstationOriginal);
            scope.remoteQueueManagementCalibrationObject.originalModel = scope.workstationOriginal;
            scope.printQueuesToBeChanged = data.printQueuesToBeChanged;
            scope.watchQueues();
            taskMaintenance('RELAY_WS_UPDATE');
          }
        })

        scope.$on('$destroy', function() {
          RELAY_WS_UPDATE_listener();
        });




      }
    };
  }

  pxWorkstationQueues.$inject = [
    'PrintQueueListPaging',  '$ngBootbox', 'toastr', '$filter', 'URLS', 'URL_PARAMS', '$location', '$routeParams',
    'WorkstationListService', 'EventServiceEvents', 'Utils', '$rootScope'
  ];

  angular
    .module('printix-admin')
    .directive('pxWorkstationQueues', pxWorkstationQueues);

})();
